import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import useSettings from "hooks/useSettings";
import LoadingScreen from "components/LoadingScreen";
import ProtectedRoute from "components/ProtectedRoute";

import LayoutV3 from "layouts/layout-v3/DashboardLayout";
import CRM from "pages/dashboards/crm";
import RegionTable from "pages/Chapters";
import ChaptersDataTable from "page-sections/Chapters-data-table";
import Chapters from "pages/Chapters";
import CT from "pages/Chapters";
import BusinessCategory from "pages/Business-category";
import Members from "pages/Members";
import Events from "pages/Event";
import ChapterAttendanceMembers from "pages/Chapter-attendance";
import SelfRegisteredMembers from "pages/Self-registered-members";

const Loadable = Component => props => {
  return <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>;
}; // dashboards

// Secret Admin Subscription Page
const SecretSubscription = Loadable(lazy(() => import("./pages/SecretSubscription")));

const LearningManagement = Loadable(lazy(() => import("./pages/dashboards/learning-management"))); // account


const AddUser = Loadable(lazy(() => import("./pages/user-list/add-new-user")));



const Profile = Loadable(lazy(() => import("./pages/profiles/profile")));
const ProfileV2 = Loadable(lazy(() => import("./pages/profiles/profile-v2"))); // profile

const DataTableV2 = Loadable(lazy(() => import("./pages/data-table/data-table-v2"))); // invoice

const Login = Loadable(lazy(() => import("./pages/authentication/login")));
const LoginV2 = Loadable(lazy(() => import("./pages/authentication/login-v2")));
const Register = Loadable(lazy(() => import("./pages/authentication/register")));
const RegisterV2 = Loadable(lazy(() => import("./pages/authentication/register-v2")));
const NewPassword = Loadable(lazy(() => import("./pages/authentication/new-password")));
const ForgetPassword = Loadable(lazy(() => import("./pages/authentication/forget-password")));
const ForgetPasswordV2 = Loadable(lazy(() => import("./pages/authentication/forget-password-v2")));
const TwoStepVerify = Loadable(lazy(() => import("./pages/authentication/two-step-verification"))); // admin ecommerce


const Error = Loadable(lazy(() => import("./pages/404")));

const ActiveLayout = () => {
  const {
    settings
  } = useSettings(); // console.log(settings);

  switch (settings.activeLayout) {
    // case "layout1":
    //   return <LayoutV1 />;

    // case "layout2":
    //   return <LayoutV2 />;

    case "layout3":
      return <LayoutV3 />;

    default:
      return <LayoutV3 />;
  }
};

// Authentication guard for login/register pages
const AuthGuard = ({ children }) => {
  const userData = JSON.parse(localStorage.getItem("logged_data"))?.user;
  const isAuthenticated = !!userData;
  const userRole = userData?.role;

  if (isAuthenticated) {
    // Redirect to appropriate dashboard based on role
    return <Navigate to={userRole === 'chapter_admin' ? '/dashboard/members' : '/dashboard'} replace />;
  }

  return children;
};

const routes = () => {
  return [
    {
      path: "/",
      element: (() => {
        const userData = JSON.parse(localStorage.getItem("logged_data"))?.user;
        const userRole = userData?.role;
        console.log("🚀 ~ routes ~ userRole:", userRole)
        return <Navigate to={userRole === 'chapter_admin' ? '/dashboard/members' : '/dashboard'} replace/>;
      })()
    },
    {
      path: "login",
      element: <AuthGuard><Login /></AuthGuard>,
      title: "Login"
    },
    {
      path: "register",
      element: <AuthGuard><Register /></AuthGuard>,
      title: "Register"
    },
    {
      path: "dashboard",
      element: (
        <ProtectedRoute allowedRoles={["super_admin", "chapter_admin"]}>
          <ActiveLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute allowedRoles={["super_admin"]}>
              <CRM />
            </ProtectedRoute>
          ),
          title: "Dashboard"
        },
        {
          path: "members",
          element: (
            <ProtectedRoute allowedRoles={["chapter_admin", "super_admin"]}>
              <Members />
            </ProtectedRoute>
          ),
          title: "Members"
        },
        {
          path: "events",
          element: (
            <ProtectedRoute allowedRoles={["super_admin", "chapter_admin"]}>
              <Events />
            </ProtectedRoute>
          ),
          title: "Events"
        },
        {
          path: "business-category",
          element: (
            <ProtectedRoute allowedRoles={["super_admin"]}>
              <BusinessCategory />
            </ProtectedRoute>
          ),
          title: "Business Category"
        },
        {
          path: "chapter-attendance",
          element: (
            <ProtectedRoute allowedRoles={["chapter_admin"]}>
              <ChapterAttendanceMembers />
            </ProtectedRoute>
          ),
          title: "Meeting Report"
        },
        {
          path: "chapters",
          element: (
            <ProtectedRoute allowedRoles={["super_admin"]}>
              <CT />
            </ProtectedRoute>
          )
        },
        {
          path: "self-registered-members",
          element: (
            <ProtectedRoute allowedRoles={["super_admin"]}>
              <SelfRegisteredMembers />
            </ProtectedRoute>
          )
        },
        {
          path: "8a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d",
          element: <SecretSubscription />,
          title: "Secret Subscription"
        }
      ]
    },
    {
      path: "*",
      element: <Error />
    }
  ];
};

export default routes;